module.exports = __webpack_public_path__ + "static/media/patient2.9524ad8d.jpg";